import { render } from "./Confirm.vue?vue&type=template&id=1b5b35f2"
import script from "./Confirm.vue?vue&type=script&lang=js"
export * from "./Confirm.vue?vue&type=script&lang=js"
script.render = render

export default script